webpackJsonp([0],{

/***/ "07PK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      terminal: '',
      commandEntered: '',
      lastCommand: '',
      theme: 'theme_main'
    };
  },

  mounted: function mounted() {
    this.startMessage();
  },
  updated: function updated() {
    var container = this.$el.querySelector('.main');
    container.scrollTop = container.scrollHeight;
  },

  computed: {
    mainTheme: function mainTheme() {
      return this.theme;
    }
  },
  methods: {
    startMessage: function startMessage() {
      this.terminal += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;.<br />&nbsp;&nbsp;&nbsp;\\ | /<br />&nbsp;\'-.;;;.-\'<br />-==;;;;;==-<br />&nbsp;.-\';;;\'-.<br />&nbsp;&nbsp;&nbsp;/ | \\<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\'<br />Welcome to Made By Them. We like to make the complex easy to use.</a><br /><br />We can help you innovate through knowledge of advanced technologies & human-centered design.<br /><br />Please type ‘<b>help</b>’ to view a list of commands.';
    },
    runCommand: function runCommand() {
      var cleanText = this.commandEntered.replace(/<\/?[^>]+(>|$)/ig, '').toLowerCase().trim();
      if (cleanText !== '') {
        this.terminal += '<br />> ~ ' + cleanText;
        this.lastCommand = cleanText;
        this.commandEntered = '';
        switch (cleanText) {
          case 'help':
            this.terminal += '<br /><strong>Available commands</strong>:<table style="undefined;table-layout: fixed; width: 100%"><colgroup><col style="width: 30%"><col style="width: 40%"><col style="width: 30%"></colgroup><tr><td>about</td><td>portfolio</td><td>uiux</td></tr><tr><td>buy2weeks</td><td>contact</td><td>themes</td></tr><tr><td>freeWriting</td><td>chatBot</td><td>clear</td></tr><tr></tr></table>';
            break;
          case 'clear':
            this.terminal = 'Please type ‘<b>help</b>’ to view a list of commands.';
            break;
          case 'about':
            this.terminal += '<br />We take borrowed truths to become knowledgeable. But to be knowledgeable is not to know.<br /><br />I studied both Mechanical Engineering and Graphic Design. Engineering has given me a solid foundation to build a career in technology. Art and design being my passion, has enabled me to understand the user. I’ve married the two worlds in the businesses and products I’ve built over the years.<br /><br /><ul><li><a href="https://www.linkedin.com/in/jamiegodwin/" target="_blank">LinkedIn</a></li><li><a href="https://www.dropbox.com/s/j17d1n09mfnptmt/james_godwin_ui_ux_portfolio.pdf?dl=0" target="_blank">Portfolio</a></li><li><a href="https://jamesgodwin.deviantart.com/gallery/" target="_blank">Paintings</a></li><li><a href="https://justbeing.life" target="_blank">JustBeing</a> EQ training course</li><li><a href="https://Just6.life" target="_blank">Just 6 Seconds</a></li><li><a href="https://fettle.life" target="_blank">Fettle.life</a></li></ul>This app was developed in Vue.js.<hr>You can also visit <a href="https://jamesgodwin.me/" target="_blank">jamesgodwin.me</a> to see what I\'m doing now.<hr />Please type ‘<b>help</b>’ to view a list of commands.<hr>';
            break;
          case 'uiux':
            this.terminal += '<br />We use design sprints to answer critical business questions through design, prototyping and customer interviews.<br /><div class="moo-items" style="display: inline-block; margin: 0.8em; vertical-align:top;"><div class="moo-items-content" style="width: 200px;"><i class="fa fa-bullseye" style="font-size: 16px; padding-right: 5px;" aria-hidden="true"></i><strong>Unpack</strong><br />We start at the end and agree to a long-term goal. The business owners and experts will share their knowledge.</div></div><div class="moo-items" style="display: inline-block; margin: 0.8em; vertical-align:top;"><div class="moo-items-content" style="width: 200px;"><i class="fa fa-pencil" style="font-size: 16px; padding-right: 5px;" aria-hidden="true"></i><strong>Sketch</strong><br />Once we understand the problem at hand, we’ll attempt to create as many solutions as possible.</div></div><div class="moo-items" style="display: inline-block; margin: 0.8em; vertical-align:top;"><div class="moo-items-content" style="width: 200px;"><i class="fa fa-puzzle-piece" style="font-size: 16px; padding-right: 5px;" aria-hidden="true"></i><strong>Decide</strong><br />With all of the potential solutions, we’ll work as a team to share, discuss, and decide on the best solution.</div></div><div class="clearfix"><div class="moo-items" style="display: inline-block; margin: 0.8em; vertical-align:top;"><div class="moo-items-content" style="width: 200px;"><i class="fa fa-files-o" style="font-size: 16px; padding-right: 5px;" aria-hidden="true"></i><strong>Prototype</strong><br />With a thought-out solution and storyboard, we’ll spend an entire day turning the solution into a working prototype.</div></div><div class="moo-items" style="display: inline-block; margin: 0.8em; vertical-align:top;"><div class="moo-items-content" style="width: 200px;"><i class="fa fa-users" style="font-size: 16px; padding-right: 5px;" aria-hidden="true"></i><strong>Interview</strong><br />With our prototype, we’ll invite real people into the office to conduct interviews. We’ll learn about the product as users react.</div></div><div class="moo-items" style="display: inline-block; margin: 0.8em; vertical-align:top;"><div class="moo-items-content" style="width: 200px;"><i class="fa fa-rocket" style="font-size: 16px; padding-right: 5px;" aria-hidden="true"></i><strong>Build</strong><br />With a prototype and real customer feedback, we have answered the important questions about our design. Time to build.</div></div><hr>You can also visit <a href="https://jamesgodwin.me/" target="_blank">jamesgodwin.me</a> to see what I\'m doing now.<hr />Please type ‘<b>help</b>’ to view a list of commands.<hr>';
            break;
          case 'portfolio':
            this.terminal += '<br />Thanks for taking a look at my portfolio. Please follow the link below to download :)<br /><br /><ul><li><a href="https://www.dropbox.com/s/j17d1n09mfnptmt/james_godwin_ui_ux_portfolio.pdf?dl=0" target="_blank">James Godwin - Portfolio</a></li><li><a href="https://www.linkedin.com/in/jamiegodwin/" target="_blank">LinkedIn</a></li></ul><hr>You can also visit <a href="https://jamesgodwin.me/" target="_blank">jamesgodwin.me</a> to see what I\'m doing now.<hr />Please type ‘<b>help</b>’ to view a list of commands.<hr>';
            break;
          case 'buy2weeks':
            this.terminal += '<br /><strong>Pay only for the next sprint</strong>. We apply agile processes to both the software development and the business sides of my projects. We work in 2-week sprints and bill clients accordingly. This gives the clients extreme flexibility and predictability in both the project development process and resource management.<br /><br />No long-term commitments required; you can pause the work at any time. Startups love the flexibility! And it’s extremely useful for my enterprise clients since it allows them to be as nimble as startups. If we don’t deliver, no payment. We are also willing to take a risk.<hr>You can also visit <a href="https://jamesgodwin.me/" target="_blank">jamesgodwin.me</a> to see what I\'m doing now.<hr />Please type ‘<b>help</b>’ to view a list of commands.<hr>';
            break;
          case 'contact':
            this.terminal += '<br /><i class="fa fa-envelope-o" style="font-size: 12px; padding-right: 5px;" aria-hidden="true"></i><a href="mailto:james@madebythem.com">james@madebythem.com</a> | <a href="https://www.linkedin.com/in/jamiegodwin/" target="_blank"><i class="fa fa-linkedin" style="font-size: 14px;" aria-hidden="true"></i></a> | <a href="https://www.dropbox.com/s/j17d1n09mfnptmt/james_godwin_ui_ux_portfolio.pdf?dl=0" target="_blank">Portfolio</a></li><hr>You can also visit <a href="https://jamesgodwin.me/" target="_blank">jamesgodwin.me</a> to see what I\'m doing now.<hr />Please type ‘<b>help</b>’ to view a list of commands.<hr>';
            break;
          case 'chatbot':
            this.terminal += '<br /><strong>Is the web dead?</strong><br />The future interfaces will be nothing like what we use today. We will interface with AI and chatBots. Why painfully navigate a site for information? Why can’t you ask a chatBot to get the info? Or simply the highlights?<br /><br/><strong>The questions I ask.</strong><ul><li>Explore the possibility of building a chatbot to interface with the app commands</li><li>How useful could I make it?</li><li>Could i use voice?</li><li>add more terminal-like functionality like the last command, tab commands</li></ul>';
            break;
          case 'freewriting':
            this.terminal += '<br />Free writing is one of the best and easiest exercises you can do. Free writing is a way to generate new ideas and to go places with your creative mind you wouldn’t go otherwise.<br /><br />For five minutes, write non-stop: don’t lift your fingers from the keyboard or your pen from the page. Just keep writing. Don’t stop to ponder or make corrections. Just keep writing. Forget the rules of formal English. You are writing only for yourself and no one is going to look and point out your errors.<br /><br />If you find yourself stuck for something to say, just keep repeating the last word you have written, or write, "I’m stuck, I’m stuck" until a fresh thought emerges.<br /><br />After a few minutes, the results may not look pretty, but you might see a spark of genius.<br /><br />The point of this is I want to write a tool in this interface that will allow you to write for 5 min and if you pause too long to think, your effort will fade away until you begin again. Wait too long and it’s gone :( After 5 min you can then save your genius. The idea is to force you into the zone and you never know what will pop up :)';
            break;
          case 'themes':
            this.terminal += '<br />Available themes:<table style="undefined;table-layout: fixed; width: 100%"><colgroup><col style="width: 30%"><col style="width: 30%"><col style="width: 30%"></colgroup><tr><td>default</td><td>dreams</td><td>future</td></tr><tr><td>stars</td><td>calm</td><td>mountains</td></tr><tr><td>mist</td><td>peace</td><td>snow</td></tr><tr><td>tooMuch</td><td>dark</td><td>solarized</td></tr></table>';
            break;
          case 'default':
            this.theme = 'theme_main';
            break;
          case 'dreams':
            this.theme = 'theme_dreams';
            break;
          case 'future':
            this.theme = 'theme_future';
            break;
          case 'stars':
            this.theme = 'theme_stars';
            break;
          case 'calm':
            this.theme = 'theme_calm';
            break;
          case 'mountains':
            this.theme = 'theme_mountains';
            break;
          case 'mist':
            this.theme = 'theme_mist';
            break;
          case 'peace':
            this.theme = 'theme_peace';
            break;
          case 'snow':
            this.theme = 'theme_snow';
            break;
          case 'toomuch':
            this.theme = 'theme_toomuch';
            break;
          case 'dark':
            this.theme = 'theme_dracula';
            break;
          case 'solarized':
            this.theme = 'theme_solarizeddark';
            break;
          default:
            this.terminal += '<br />That was not a command, type ‘help’ to view list of commands';
        }
      }
    }
  }
});

/***/ }),

/***/ "8VyH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BXwX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FreeWriting_vue__ = __webpack_require__("Zh3+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcaf06d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FreeWriting_vue__ = __webpack_require__("Cz8w");
function injectStyle (ssrContext) {
  __webpack_require__("8VyH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fcaf06d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FreeWriting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcaf06d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FreeWriting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Blxd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-element",class:_vm.mainTheme},[_c('div',{staticClass:"set-position"},[_c('div',{staticClass:"main"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.terminal)}}),_vm._v(" "),_c('div',{staticClass:"terminal-input"},[_vm._v("\n      > ~ "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.commandEntered),expression:"commandEntered"}],attrs:{"type":"text","autofocus":"","tabindex":"-1"},domProps:{"value":(_vm.commandEntered)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.runCommand.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.commandEntered=$event.target.value}}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cz8w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-element",class:_vm.mainTheme},[_c('div',{staticClass:"set-position"},[_c('div',{staticClass:"main"},[_vm._m(0),_vm._v(" "),_c('p',[_vm._v("Begin typing, rememebr if you pause too long all is gone.")]),_vm._v(" "),(_vm.inputarea)?_c('div',[_c('button',{staticClass:"freewrite-btn",on:{"click":_vm.startWriting}},[_vm._v("Start")])]):_c('div',[_c('button',{staticClass:"freewrite-btn",on:{"click":_vm.restartWriting}},[_vm._v("Stop")]),_vm._v(" "),_c('div',{staticClass:"terminal-input"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.textEntered),expression:"textEntered"}],attrs:{"autofocus":"autofocus","tabindex":"-1","rows":"25","cols":"60"},domProps:{"value":(_vm.textEntered)},on:{"input":function($event){if($event.target.composing){ return; }_vm.textEntered=$event.target.value}}})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Free Writing")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e60f95e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("vU96");
function injectStyle (ssrContext) {
  __webpack_require__("zQsb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e60f95e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HelloWorld__ = __webpack_require__("gORT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FreeWriting__ = __webpack_require__("BXwX");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HelloWorld__["a" /* default */]
  }, {
    path: '/freewriting',
    name: 'Freewriting',
    component: __WEBPACK_IMPORTED_MODULE_3__components_FreeWriting__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Zh3+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FreeWriting',
  data: function data() {
    return {
      textEntered: '',
      theme: 'theme_main',
      inputarea: true
    };
  },

  methods: {
    startWriting: function startWriting() {
      this.inputarea = false;
    },
    restartWriting: function restartWriting() {
      this.inputarea = true;
      this.textEntered = '';
    }
  }
});

/***/ }),

/***/ "gORT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__ = __webpack_require__("07PK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2391091d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__ = __webpack_require__("Blxd");
function injectStyle (ssrContext) {
  __webpack_require__("wFcC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2391091d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2391091d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vU96":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wFcC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "zQsb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.118ae266e31cb25cb075.js